import { inject, Injector } from '@angular/core';
import { signalStore, withMethods, withProps, withState } from '@ngrx/signals';
import { initialFormaGiuridicaState } from './forma_giuridica.state';
import { getFormaGiuridica } from './forma_giuridica.utility';
import { GetFormaGiuridicaGQL } from '../../_graphql/generated';

export const FormaGiuridicaStore = signalStore(
  { providedIn: 'root' },
  withState(initialFormaGiuridicaState),
  withProps(() => ({
    getter: inject(GetFormaGiuridicaGQL),
  })),
  withMethods(({ getter, ...store }, injector = inject(Injector)) => ({
    init: getFormaGiuridica(injector, store, getter),
  })),
);
